<template>
  <div>
    <div class="common-form">添加模板</div>
    <el-form ref="form" :model="form" label-width="200px">
      <el-form-item label="场景" :rules="[{ required: true, message: '请选择场景' }]" prop="sence_id">
        <el-select class="max-w460" style="width:100%" filterable v-model="form.sence_id" placeholder="请选择">
          <el-option v-for="(item,index) in senceDetailList" :key="index" :value="item.sence_id" :label="item.sence_name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="场景标题" :rules="[{ required: true, message: '场景标题不能为空' }]" prop="sence_title">
        <el-input class="max-w460" v-model="form.sence_title"></el-input>
      </el-form-item>
      <el-form-item label="场景内容" prop="sence_content">
        <el-input class="max-w460" v-model="form.sence_content"></el-input>
      </el-form-item>
      <el-form-item label="推送程序" :rules="[{ required: true, message: '请选择推送程序' }]" prop="source">
        <el-select class="max-w460" style="width:100%" v-model="form.source" placeholder="请选择">
          <el-option :value="1" label="小程序"></el-option>
          <el-option :value="2" label="APP"></el-option>
          <el-option :value="3" label="h5"></el-option>
          <el-option :value="4" label="全部"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="手机类型" :rules="[{ required: true, message: '请选择手机类型' }]" prop="platform_type">
        <el-select class="max-w460" style="width:100%" v-model="form.platform_type" placeholder="请选择">
          <el-option :value="1" label="andiord"></el-option>
          <el-option :value="2" label="ios"></el-option>
          <el-option :value="3" label="全部"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="推送规则" :rules="[{ required: true, message: '请选择推送规则' }]" prop="rule.type ">
        <el-select class="max-w460" style="width:100%" v-model="form.rule.type " placeholder="请选择">
          <el-option :value="2" label="自动推送"></el-option>
          <el-option :value="1" label="手动推送"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if='form.rule.type==2' label="推送时间" :rules="[{ required: true, message: '请选择推送规则' }]" prop="rule.time">
        <el-date-picker class="max-w460" style="width:100%" type="datetime" v-model="form.rule.time" placeholder="选择日期时间" value-format="timestamp">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="跳转路径" prop="url">
        <el-input class="max-w460" v-model="form.url"></el-input>
      </el-form-item>
      <el-form-item label="跳转页面" prop="page">
        <el-input class="max-w460" v-model="form.page"></el-input>
      </el-form-item>
      <el-form-item label="用户分组" prop="user_group">
        <el-input class="max-w460" v-model="form.user_group"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">关闭</el-radio>
          <el-radio :label="0">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="所属分类" :rules="[{ required: true, message: '请选择所属分类' }]" prop="user_type">
        <el-select class="max-w460" style="width:100%" v-model="form.user_type" placeholder="请选择">
          <el-option :value="1" label="技师"></el-option>
          <el-option :value="2" label="用户"></el-option>
          <el-option :value="3" label="商家"></el-option>
          <el-option :value="4" label="全部"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即添加</el-button>
      </el-form-item>
    </el-form>
    <!--图片组件-->
    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import AppSettingApi from "@/api/appsetting.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  data() {
    return {
      senceDetailList: [],
      isProductUpload: false,
      form: {
        sence_id: "",
        sence_title: "",
        user_type: "",
        user_group: 0, // 用户分组，暂时没用 默认0
        type: "", //手机类型
        sence_content: "",
        source: "",
        status: 1,
        page: "",
        url: "", //跳转路径
        rule: {
          type: 1,
          time: ""
        }
      }
    };
  },
  created() {
    this.getsenceData();
  },

  methods: {
    // 详情
    getsenceData: function() {
      let self = this;
      AppSettingApi.senceList(
        {
          page: 1,
          pageSize: 10000
        },
        true
      )
        .then(res => {
          self.senceDetailList = res.data.list.data;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    onSubmit() {
      let self = this;
      let params = self.form;
      params.rule.time = Math.floor(params.rule.time / 1000);
      self.$refs.form.validate(valid => {
        if (valid) {
          AppSettingApi.templateJGAdd(params, true)
            .then(data => {
              self.$message({
                message: "添加成功",
                type: "success"
              });
              self.from = {
                template_name: "",
                status: 1
              };
              self.$router.push("/appsetting/template/index");
              // Technician
            })
            .catch(error => {});
        }
      });
    }
  }
};
</script>




<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  line-height: 20px;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/appsetting/template/add.vue